import { LessonProblem, LESSON_STATUS } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { filterLoadedLessonProblems } from 'common.components/lesson/selectors/utils';
import { isLessonCompleted, isLessonInProgress } from 'common.components/lesson/utils';
import * as problemsSelectors from 'store/problems/selectors';
import { LessonInfo } from 'store/problems/typings';

export const getLoadedLessonProblems = createSelector(lessonViewSelectors.getLessonViewProblems, (lessonProblems) => {
    return filterLoadedLessonProblems(lessonProblems);
});

/**
 * @returns { problemLink.id: problemsUsagesCount }
 */
export const getLessonProblemsInCourseCount = createSelector(
    [problemsSelectors.getProblemsInCourse, lessonSelectors.getLoadedLessonProblems, lessonSelectors.getCLessonId],
    (
        problemsInCourse: Record<number, Array<LessonInfo>>,
        problemsInLesson: Array<LessonProblem>,
        clessonId: number
    ): Record<number, number> => {
        return problemsInLesson.reduce((result: Record<number, number>, problem: LessonProblem) => {
            if (!problem.problem) {
                return result;
            }
            if (problemsInCourse[problem.problem.id]) {
                result[problem.id] = problemsInCourse[problem.problem.id].filter(
                    (clesson) => clesson.id !== clessonId
                ).length;
            }

            return result;
        }, {});
    }
);

export const getShouldShowUsages = createSelector(lessonSelectors.getLessonStatus, (status: LESSON_STATUS): boolean => {
    return !isLessonCompleted(status) && !isLessonInProgress(status);
});
